<template>
    <div class="def-rating">
        <span v-for="i in 5" class="def-rating__item"
              :class="i <= modelValue ? 'def-rating__item_active' : ''"
              @click="changeRating(i)"
        >
            <svg>
                <use xlink:href="#svg-star"></use>
            </svg>
        </span>
    </div>
</template>

<script>
export default {
    name: 'DefRating',
    selector: '.def-rating',
    props: ['modelValue'],
    methods: {
        changeRating(newRating) {
            if (this.result == newRating) return;
            this.$emit('update:modelValue', newRating);
        }
    },
    mounted() {
        const activeItems = document.querySelectorAll('.def-rating__item_active');
        if (activeItems.length < 1) {
            const items = document.querySelectorAll('.def-rating__item');
            items.forEach(el => {
                const svg = el.querySelector('svg');
                svg.style.fill = '#eaeaea';
            })
        }
    }
}
</script>

<style lang="scss">
.def-rating {
    display: flex;
    align-items: center;
    &__item {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &_active svg {
          fill: #faa295 !important;
        }
        svg{
            width: 15px;
            height: 15px;
            fill: #eaeaea;

            @include point-md {
                width: 10px;
                height: 10px;
            }
            @include point-lg {
                width: 15px;
                height: 15px;
            }
        }

        /*&:hover ~ & svg {*/
        /*    fill: #eaeaea;*/
        /*}*/
    }
   /* &:not(:hover) {
        .def-rating__item_active ~ .def-rating__item svg{
            fill: #eaeaea;
        }
    }*/

}
</style>